import { Enumify } from "enumify";

class Stats extends Enumify {
  static AdvertiserAdOutlay = new Stats({
    name: "광고주광고비",
  });
  static IndustryAdOutlay = new Stats({
    name: "업종별광고비",
  });
  static TvRating = new Stats({
    name: "TV시청률(일일)",
  });
  static MonthlyTvRating = new Stats({
    name: "TV시청률(월간)",
  });
  static PcDomain = new Stats({
    name: "PC 도메인",
  });
  static MoblieApp = new Stats({
    name: "Mobile 앱",
  });
  static _ = this.closeEnum();

  constructor(props) {
    super();
    Object.defineProperties(this, Object.getOwnPropertyDescriptors(props));
  }
}

export default Stats;
